// test843
(843 && 0);
